<script setup lang="ts">
import type { RecommendedBanner } from '@/types/BannersTypes'
import BannerTextContentWithTest from '@/widgets/home/Banners/BannerTextContentWithTest.vue'
import Button from 'primevue/button'
import { useI18n } from 'vue-i18n'
import { useDevice } from '@/composables/useDevice'
import { computed } from 'vue'


const { bannersData } = defineProps<{
  bannersData: RecommendedBanner[],
  isBannersLoading: boolean
}>()

const emit = defineEmits<{
  (e: 'triggerBannerClick', id:number): void
}>()

const { t } = useI18n()
const { isDevice } = useDevice();

const deviceType = computed(() => isDevice.value);


</script>

<template>
  <div class="parent">
    <div  v-for="(item,index) in bannersData.slice(0,4)"  :class="`div${index + 1} skeleton-container`">
      <div
        class="left-banner-item"
        @click="emit('triggerBannerClick',item.id)"
      >
        <div class="banners-item-image">
          <img class="contain-image" :src="item.imageUrl" :alt="item.name + 'image'" />
        </div>
        <div class="banners-content">
          <div class="banners-item-title h2">
            {{ item.name }}
          </div>
          <div class="banners-text body">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
    <div class="div5 skeleton-container">
      <div class="big-image-wrapper" :style="{
        backgroundImage: `url(${bannersData[bannersData.length - 1]?.imageUrl})`
      }">
      </div>
    </div>
    <div class="div6 skeleton-container">
     <banner-text-content-with-test />
    </div>
  </div>
</template>

<style scoped>
.parent {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(8, 1fr);
  gap: 20px;
  height:117vh;
}

.div1 {
  grid-row: span 4 / span 4;
}

.div2 {
  grid-row: span 4 / span 4;
  grid-column-start: 1;
  grid-row-start: 5;
}

.div3 {
  grid-row: span 4 / span 4;
  grid-column-start: 2;
  grid-row-start: 1;
}

.div4 {
  grid-row: span 4 / span 4;
  grid-column-start: 2;
  grid-row-start: 5;
}

.div5 {
  grid-column: span 2 / span 2;
  grid-row: span 5 / span 5;
  grid-column-start: 3;
  grid-row-start: 1;
}

.div6 {
  grid-column: span 2 / span 2;
  grid-row: span 3 / span 3;
  grid-column-start: 3;
  grid-row-start: 6;
}

.left-banner-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%; /* Добавлено */
  gap:12px;
}

.banners-item-image {
  flex: 1 1 auto; /* Изменено */
  min-height: 0; /* Добавлено для правильного сжатия в flex-контейнере */
  position: relative; /* Добавлено */
}

.contain-image {
  border-radius: 28px;
  width: 100%;
  height: 100%; /* Добавлено */
  object-fit: cover; /* Добавлено для заполнения пространства с сохранением пропорций */
}

.banners-content {
  flex: 0 0 auto; /* Запрещаем растягивание и сжатие */
  /* Остальные стили banners-content */
}

.big-image-wrapper {
  width:100%;
  height: 100%;
  overflow:hidden;
  background-position: 100%;
  background-size: cover;
  border-radius: 28px;
}

@media screen and (max-width: 1024px) {
  .parent {
    display: flex;
    width: 90vw;
    overflow: hidden;
    gap: 30px;
    height: 500px;
  }

  .skeleton-container {
    min-width: 300px;
    height: 420px !important;
    width: 300px !important;
  }
}
</style>
